export const environment = {
  production: true,
  connection: {
    name: 'LH Agrarunion Softline',
    host: 'https://softline.agrarunion.rlh.at',
    port: 443,
    basePath: '/api'
  },
  androidUpdateRepository: ''
};
